// Prints anyway once this passes, so a hung crop-label request can't block the dialog.
export const PDF_PRINT_SAFETY_TIMEOUT_MS = 20000;

// Lets Recharts' ResponsiveContainer measure and draw first; printing earlier gives blank charts.
export const PDF_CHART_PAINT_DELAY_MS = 500;

// Margin boxes can't read CSS variables, so the footer mirrors $grey-600 here.
export const PDF_PAGE_FOOTER_STYLE = "font-size: 7pt; color: #6d6d6d;";
export const PDF_PAGE_MARGIN = "12mm 14mm 14mm";

// Placeholders swapped for CSS page counters, so the footer copy stays translatable.
export const PDF_PAGE_TOKEN = "__PAGE__";
export const PDF_PAGES_TOKEN = "__PAGES__";
